import { setCSSVar } from "../../utils/setCSSVar";

export class HeaderResizeObserver {
    static selector = "[data-js-header]"
    static cssVar = {
        headerHeight: "--header-height"
    }
    constructor(headerSelector = HeaderResizeObserver.selector) {
        if (HeaderResizeObserver.instance) {
            return HeaderResizeObserver.instance;
        }

        this.header = document.querySelector(headerSelector);
        if (this.header) {
            this.initResizeObserver();
            this.updateHeaderHeight();
        } else {
            console.error(`Header element with selector '${headerSelector}' not found.`);
        }

        HeaderResizeObserver.instance = this;
    }

    updateHeaderHeight() {
        const headerHeight = this.header.offsetHeight;
        setCSSVar(document.documentElement, HeaderResizeObserver.cssVar.headerHeight, `${headerHeight}px`);
    }

    initResizeObserver() {
        this.resizeObserver = new ResizeObserver(() => {
            this.updateHeaderHeight();
        });
        this.resizeObserver.observe(this.header);
    }

    static getInstance(headerSelector) {
        if (!HeaderResizeObserver.instance) {
            new HeaderResizeObserver(headerSelector);
        }
        return HeaderResizeObserver.instance;
    }
}
